import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=2c7c0f5e&"
import script from "./DataGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./DataGrid.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=2c7c0f5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VDataTable,VSpacer})
